/**
 * This file is auto-generated from ChatScaleInput.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const submitButton: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Continue';
        case 'pl':
            return 'Kontynuuj';
    }
};

export const selectValue: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Please select a value';
        case 'pl':
            return 'Proszę wybrać wartość';
    }
};

export const selectedValue: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Selected value';
        case 'pl':
            return 'Wybrana wartość';
    }
};

export const scaleLabel: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Scale rating';
        case 'pl':
            return 'Ocena na skali';
    }
};

export const noSelection: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'No selection';
        case 'pl':
            return 'Brak wyboru';
    }
};
